module.exports = __webpack_public_path__ + "static/img/yzlogo.4fb73bb8.jpeg";